import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ToolTipIcon } from './ProjectIcons';

interface TooltipProps {
  description: string | React.ReactNode;
  position?: 'top' | 'bottom' | 'bottomleft' | 'left' | 'right';
  width?: string;
  ariaLabel?: string;
}

export const Tooltip: React.FC<TooltipProps> = ({
  description,
  position = 'top',
  width = 'w-40',
  ariaLabel,
}) => {
  const { t } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);

  const getTooltipPositionClass = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2';
      case 'bottom':
        return 'top-full right-0 transform mt-2';
      case 'bottomleft':
        return 'top-full left-0 transform mt-2';
      case 'left':
        return 'right-full top-0 transform -translate-y-0 mr-2';
      case 'right':
        return 'left-full top-0 transform -translate-y-0 ml-2';
      default:
        return '';
    }
  };

  return (
    <div className="relative mb-1.5 inline-block">
      <button
        type="button"
        className="flex h-3.5 w-3.5 cursor-pointer items-center justify-center rounded-full p-0 outline-none focus:ring-2 focus:ring-unlisted-gray-lines"
        onMouseEnter={() => setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        onFocus={() => setShowTooltip(true)}
        onBlur={() => setShowTooltip(false)}
        aria-label={
          ariaLabel ??
          (typeof description === 'string'
            ? description
            : t('More information'))
        }
      >
        <span className="inline-flex h-4 w-4 -translate-y-0.5 items-center justify-center rounded-full">
          <ToolTipIcon />
        </span>
      </button>
      {showTooltip && (
        <div
          className={`${width} absolute ${getTooltipPositionClass()} z-10 rounded border border-unlisted-gray-lines bg-white p-2 text-ui-text-primary-text shadow-lg`}
        >
          {description}
        </div>
      )}
    </div>
  );
};
